import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingIndicatorService } from '../loading-indicator/loading-indicator.service';

export const httpInterceptor: HttpInterceptorFn = (request, next) => {
  const loadingIndicatorService = inject(LoadingIndicatorService);

  loadingIndicatorService.newConnection();
  return next(request).pipe(
    finalize(() => loadingIndicatorService.connectionClosed())
  );
};
